var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGetAnswers = function SvgGetAnswers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "var(--c-blue2)",
    strokeWidth: 2,
    d: "M4 36a1 1 0 0 1 1-1h50a1 1 0 0 1 1 1v17a1 1 0 0 1-1 1H9a5 5 0 0 1-5-5V36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5 5.5a1 1 0 0 0-1 1v42.48a5 5 0 0 0 5 5h42.86a5 5 0 0 1-4.98-5V35.94a1 1 0 0 1 1-.94h7.4-8.4V6.5a1 1 0 0 0-1-1H5Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--c-blue2)",
    d: "M4 35.96 5 36v-.04H4Zm47.86 18.02v1-2 1Zm-4.98-8.41-1-.06v.06h1Zm0-9.63-1-.05v.05h1Zm8.4-.94v1l.01-2v1Zm0 0v-1 1Zm-8.4 0h-1v1h1v-1ZM5 6.5v-2a2 2 0 0 0-2 2h2Zm0 29.46V6.5H3v29.46h2Zm-2-.04V36h2l-2-.08ZM3 36v12.98h2V36H3Zm0 12.98a6 6 0 0 0 6 6v-2a4 4 0 0 1-4-4H3Zm6 6h42.86v-2H9v2Zm42.87-2a4 4 0 0 1-4-4h-2a6 6 0 0 0 5.99 6v-2Zm-4-4v-3.41h-2v3.4h2Zm-2-3.47 2 .11a2 2 0 0 0 0-.1h-2Zm0-9.57v9.57h2v-9.57h-2Zm2 .06v-2a2 2 0 0 0-2 1.89l2 .1Zm0 0h7.42v-2h-7.41v2Zm7.42-2-.01 2 .01-2Zm0 0h-8.41v2h8.4v-2ZM45.87 6.5V35h2V6.5h-2Zm0 0h2a2 2 0 0 0-2-2v2ZM5 6.5h40.88v-2H5v2Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 10.05,
    y: 17,
    fill: "#fff",
    stroke: "var(--c-main-menu-num)",
    strokeWidth: 2,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 21.05,
    y: 27,
    fill: "#fff",
    stroke: "var(--c-main-menu-num)",
    strokeWidth: 2,
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 1,
    x: 0.5,
    y: -0.5,
    fill: "#fff",
    stroke: "var(--c-main-menu-num)",
    rx: 0.5,
    transform: "matrix(1 0 0 -1 10.05 30)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 21.5,
    height: 1,
    x: 0.5,
    y: -0.5,
    fill: "#fff",
    stroke: "var(--c-main-menu-num)",
    rx: 0.5,
    transform: "matrix(1 0 0 -1 16.05 20)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 10.05,
    y: 37,
    fill: "#fff",
    stroke: "var(--c-blue2)",
    strokeWidth: 2,
    rx: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 21.05,
    y: 37,
    fill: "#fff",
    stroke: "var(--c-blue2)",
    strokeWidth: 2,
    rx: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 32.05,
    y: 27,
    fill: "#fff",
    stroke: "var(--c-blue2)",
    strokeWidth: 2,
    rx: 1
  })));
};
export default SvgGetAnswers;